/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Team_Manager_Import_In_ProgressInputs */



/**
* | output |
* | --- |
* | "Adding members… {done} of {total}" |
*
* @param {Team_Manager_Import_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_in_progress = /** @type {((inputs: Team_Manager_Import_In_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_In_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ajout des membres… ${i?.done} sur ${i?.total}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Mitglieder werden hinzugefügt… ${i?.done} von ${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Aggiunta dei membri… ${i?.done} di ${i?.total}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Добавление участников… ${i?.done} из ${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Añadiendo miembros… ${i?.done} de ${i?.total}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在添加成员… ${i?.done}/${i?.total}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`メンバーを追加中… ${i?.done} / ${i?.total}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सदस्य जोड़े जा रहे हैं… ${i?.total} में से ${i?.done}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A adicionar membros… ${i?.done} de ${i?.total}`)
	return /** @type {LocalizedString} */ (`Adding members… ${i?.done} of ${i?.total}`)
});